import Person from 'assets/images/farm/modal/moshaver.svg';
import Portal from 'components/portal';
import useSetWanted from 'components/modal/hooks/useSetWanted';

const AddWantedModalFarm = ({
  showModal,
  setShowModal,
  title,
  city,
  state,
  app,
  guid,
}: IAddWantedModalProps) => {
  const {isLoading, mutate} = useSetWanted(setShowModal);
  return (
    <>
      {showModal && (
        <Portal>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none mx-8 ">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex flex-col justify-center items-center p-5  rounded-t">
                  <img src={Person} alt="person" />
                </div>
                <div className="relative px-3 flex-auto ">
                  <p className="my-1  leading-relaxed">
                    به یک نفر مشاور جهت تعیین سطح کیفیت محصول {` ${title} `}
                    {state
                      ? `در
                    محدوده
                      ${state},
                    `
                      : city
                      ? `${city}`
                      : ''}
                    نیاز دارم.
                  </p>
                </div>
                <div className="flex w-full px-2 py-4 ">
                  <button
                    className=" text-center py-4 rounded-md bg-green-1 text-white w-1/2"
                    onClick={() => {
                      const payload = {
                        post_guid: guid,
                        app: 'FARM',
                      };
                      !isLoading && mutate(payload);
                    }}
                  >
                    ارسال درخواست
                  </button>
                  <button
                    className=" text-center py-4 rounded-md text-green-1 bg-white w-1/2 "
                    onClick={() => setShowModal(false)}
                  >
                    انصراف
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="opacity-25 fixed inset-0 z-40 bg-black -mx-3"
            onClick={() => setShowModal(false)}
          ></div>
        </Portal>
      )}
    </>
  );
};

export default AddWantedModalFarm;
